export default "icons-hour-glass"